import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import PropTypes from "prop-types";

export default function InvoiceTools(props) {
    return (
        <div className=" flex justify-content-around h-auto ml-1 g-1 flex-shrink-1 ">
            <Button icon="pi pi-plus" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("ADD")} disabled={props.invNumber === 0} />
            <Button icon="pi pi-print" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("PRINT")}  disabled={props.invNumber === 0}/>
            <Button icon="pi pi-trash" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("DELETE")} disabled={props.invNumber === 0 || (props.isApproved&!props.xFer)}/>
            <Button icon="pi pi-undo" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("UNDO")}/>
            <Button icon="pi pi-thumbs-up" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("POST")} disabled= {!(props.isDelivered) || (props.isPosted)&&!(props.xFer)}/>
            <Button icon="pi pi-thumbs-down" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("UNPOST")} disabled={!props.isPosted}/>
            <Button icon="pi pi-save" className="mr-1 invoice-tool-btn" onClick={()=>props.setAction("SAVE")} disabled={props.isPosted || props.customerId===0}/>
        </div>
    )
}
InvoiceTools.propTypes = {
    setAction : PropTypes.func.isRequired,
    isPosted : PropTypes.bool.isRequired,
    isApproved : PropTypes.bool.isRequired,
    isDelivered : PropTypes.bool.isRequired,
    invNumber : PropTypes.number.isRequired,
    customerId : PropTypes.number.isRequired,
    xFer : PropTypes.bool.isRequired,
}
{/*<Toolbar start={startContent}   />*/}